import Swiper from 'swiper';
import { Autoplay, EffectFade } from 'swiper/modules';

console.log('swiper');

new Swiper('.swiper', {
    modules: [Autoplay, EffectFade],
    autoplay: {
        delay: 3000,
        disableOnInteraction: true,
    },
    effect: 'fade',
});
